var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[(this.$route.name === "profileEmployee")?_c('b-row',[_c('DATOEMPLOYEE'),_c('PROFILE'),_c('WIDGETCOMMENT',{attrs:{"profile":this.getEmployeeProfile}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }